<template>
    <div>
        <ly-dialog v-model="dialogVisible" :title="loadingTitle" width="640px" :before-close="handleClose">
            <el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" label-position="right" label-width="auto">
                <el-form-item label="用户名称：" prop="name">
                    <el-input v-model="formData.name"></el-input>
                </el-form-item>
                <el-form-item label="登陆账号：" prop="username">
                    <el-input v-model.trim="formData.username"></el-input>
                </el-form-item>
                <el-form-item label="登录密码：">
                    <el-input v-model.trim="formData.password" :show-password="true" placeholder="不填则默认123456"></el-input>
                </el-form-item>
                <el-form-item label="功能权限：">
                    <div>
                        <el-checkbox-group v-model="formData.permissions">
                            <div style="display: flex; align-items: center; margin-bottom: 8px;">
                                <el-checkbox label="view_bill">查看账单</el-checkbox>
                                <span style="margin-left: 10px; color: #f56c6c; font-size: 12px;">查看账单列表和详情</span>
                            </div>
                            <div style="display: flex; align-items: center; margin-bottom: 8px;">
                                <el-checkbox label="download_bill">下载账单</el-checkbox>
                                <span style="margin-left: 10px; color: #f56c6c; font-size: 12px;">下载账单文件</span>
                            </div>
                            <div style="display: flex; align-items: center; margin-bottom: 8px;">
                                <el-checkbox label="view_stats">查看统计报表</el-checkbox>
                                <span style="margin-left: 10px; color: #f56c6c; font-size: 12px;">Dashboard和统计报表</span>
                            </div>
                            <div style="display: flex; align-items: center;" v-if="canGrantManageOrg">
                                <el-checkbox label="manage_org">组织管理</el-checkbox>
                                <span style="margin-left: 10px; color: #f56c6c; font-size: 12px;">邀请Link、管理OU、绑定策略</span>
                            </div>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item label="数据权限：">
                    <div style="margin-bottom: 10px;">
                        <el-button size="small" @click="showDataScopeDialog = true">设置数据权限</el-button>
                        <span style="margin-left: 10px; color: #909399; font-size: 12px;">
                            已选: {{ dataScopeSummary }}
                        </span>
                    </div>
                </el-form-item>
                <el-form-item label="状态：" prop="is_active">
                    <div style="display: flex; align-items: center;">
                        <el-switch
                            v-model="formData.is_active"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                        </el-switch>
                        <span style="margin-left: 10px; color: #f56c6c; font-size: 12px;">开启后子账号可以登录，关闭后禁止登录</span>
                    </div>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="handleClose" :loading="loadingSave">取消</el-button>
                <el-button type="primary" @click="submitData" :loading="loadingSave">确定</el-button>
            </template>
        </ly-dialog>

        <!-- 数据权限设置弹窗 -->
        <el-dialog v-model="showDataScopeDialog" title="设置数据权限" width="700px">
            <div style="margin-bottom: 10px; color: #606266;">
                选择可访问的Link（按Payer分组）
            </div>
            <el-tree
                ref="linkTree"
                :data="linkTreeData"
                show-checkbox
                node-key="id"
                :props="{children: 'children', label: 'label'}"
                :default-checked-keys="selectedLinkIds"
                @check="handleTreeCheck"
            >
            </el-tree>
            <template #footer>
                <el-button @click="showDataScopeDialog = false">取消</el-button>
                <el-button type="primary" @click="saveDataScope">确定</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import {apiPartnerSubAccountAdd, apiPartnerSubAccountEdit, getAvailablePayers, getAvailableLinks} from "@/api/api";
    import LyDialog from "../../../components/dialog/dialog";
    import md5 from 'js-md5'
    export default {
        components: {LyDialog},
        emits: ['refreshData'],
        name: "addSubAccount",
        data() {
            return {
                dialogVisible:false,
                loadingSave:false,
                loadingTitle:'',
                formData:{
                    name:'',
                    username:'',
                    password:'',
                    permissions:[],
                    data_scope: null,
                    is_active:true
                },
                showDataScopeDialog: false,
                linkTreeData: [],
                selectedLinkIds: [],
                rules:{
                    name: [
                        {required: true, message: '请输入用户名称',trigger: 'blur'}
                    ],
                    username: [
                        {required: true, message: '请输入用户账号',trigger: 'blur'}
                    ],
                    is_active: [
                        {required: true, message: '请选择是否启用',trigger: 'blur'}
                    ]
                }
            }
        },
        computed: {
            currentUserType() {
                try {
                    return Number((JSON.parse(localStorage.getItem('userInfo') || '{}').type) || 0)
                } catch (e) { return 0 }
            },
            // 只有 admin (type=1) 才能授予组织管理权限；二代 (type=2) 自身无此权限，不能授予
            canGrantManageOrg() {
                return this.currentUserType === 1
            },
            allowedPermissions() {
                const base = ['view_bill', 'download_bill', 'view_stats']
                return this.canGrantManageOrg ? [...base, 'manage_org'] : base
            },
            dataScopeSummary() {
                const count = this.selectedLinkIds.length
                if(count === 0) return '未设置（继承父账号权限）'
                return `${count}个Link`
            }
        },
        methods:{
            handleClose() {
                this.dialogVisible=false
                this.loadingSave=false
            },
            addSubAccountFn(item,flag) {
                this.loadingTitle=flag
                this.dialogVisible=true
                this.loadPayersAndLinks()
                // 深拷贝，避免直接引用并篡改表格行数据
                this.formData=item ? JSON.parse(JSON.stringify(item)) : {
                    name:'',
                    username:'',
                    password:'',
                    permissions:[],
                    data_scope: null,
                    is_active:true
                }
                // 编辑时密码留空，不回显也不携带原值
                this.formData.password=''
                // 解析permissions
                if(item && item.permissions) {
                    if(typeof item.permissions === 'string') {
                        try {
                            const perms = JSON.parse(item.permissions)
                            this.formData.permissions = Object.keys(perms).filter(k => perms[k])
                        } catch(e) {
                            this.formData.permissions = []
                        }
                    } else if(typeof item.permissions === 'object') {
                        this.formData.permissions = Object.keys(item.permissions).filter(k => item.permissions[k])
                    }
                }
                // 解析data_scope
                if(item && item.data_scope) {
                    const scope = typeof item.data_scope === 'string' ? JSON.parse(item.data_scope) : item.data_scope
                    this.selectedLinkIds = scope.links || []
                } else {
                    this.selectedLinkIds = []
                }
            },
            async loadPayersAndLinks() {
                try {
                    const linkRes = await getAvailableLinks()
                    if(linkRes && linkRes.code === 2000) {
                        const linkData = Array.isArray(linkRes.data) ? linkRes.data : (linkRes.data?.data || [])
                        
                        // 按payer_id分组
                        const payerMap = {}
                        linkData.forEach(link => {
                            const payerId = link.payer_id || 'unknown'
                            if(!payerMap[payerId]) {
                                payerMap[payerId] = {
                                    id: `payer_${payerId}`,
                                    label: `Payer: ${payerId}`,
                                    children: []
                                }
                            }
                            payerMap[payerId].children.push({
                                id: link.link_id,
                                label: `${link.name || link.link_id} (${link.link_id})`
                            })
                        })
                        
                        this.linkTreeData = Object.values(payerMap)
                    }
                } catch(e) {
                    console.error('加载数据失败', e)
                }
            },
            handleTreeCheck() {
                const checkedNodes = this.$refs.linkTree.getCheckedNodes()
                this.selectedLinkIds = checkedNodes
                    .filter(node => !node.children)
                    .map(node => node.id)
            },
            saveDataScope() {
                // 根据选中的link提取payer
                const checkedNodes = this.$refs.linkTree.getCheckedNodes()
                const links = checkedNodes.filter(n => !n.children).map(n => n.id)
                const payers = [...new Set(links.map(linkId => {
                    // 从 linkTreeData 中找到该link所属的payer
                    for(let payer of this.linkTreeData) {
                        if(payer.children.some(c => c.id === linkId)) {
                            return payer.id.replace('payer_', '')
                        }
                    }
                    return null
                }).filter(p => p))]
                
                this.formData.data_scope = {
                    payers: payers,
                    links: links
                }
                this.showDataScopeDialog = false
            },
            submitData() {
                this.$refs['rulesForm'].validate((valite)=>{
                    if(valite) {
                        this.loadingSave=true
                        let param = {
                            ...this.formData
                        }
                        // 子账号不需要角色，继承父账号
                        delete param.role
                        if(this.formData.nickname=="" || this.formData.nickname== undefined || this.formData.nickname.length<=0 || this.formData.nickname=='""'){
                            param.nickname = this.formData.name
                        }
                        param.dept='d2c03bd9-dad0-4262-88ca-c3681d224fc3';
                        if(param.password){
                            param.password=md5(param.password);
                        }
                        // 处理permissions（防御性过滤：只保留当前角色可授予的项）
                        if(param.permissions && Array.isArray(param.permissions)) {
                            const allowed = new Set(this.allowedPermissions)
                            const permsObj = {}
                            param.permissions.forEach(p => {
                                if (allowed.has(p)) permsObj[p] = true
                            })
                            param.permissions = permsObj
                        }
                        // 处理data_scope
                        if(param.data_scope) {
                            param.data_scope = JSON.stringify(param.data_scope)
                        }
                        if(this.formData.id){
                            apiPartnerSubAccountEdit(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData')
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }else{
                            apiPartnerSubAccountAdd(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData')
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }
                    }
                })
            }
        }
    }
</script>
